<div class="products-container">
  <div class="header">
    <div class="flex items-center">
      <i class="pi pi-box text-blue-400 mr-2 text-xl"></i>
      <h2 class="text-lg font-medium">Liste des produits</h2>
    </div>
    <div class="stats">
      <span class="stat-item">
        <i class="pi pi-tag mr-1"></i>
        Total: {{ (products ?? []).length }} produits
      </span>
    </div>
  </div>

  @if (productsLoading) {
    <div class="loading-state">
      <p-progressSpinner styleClass="w-8 h-8"></p-progressSpinner>
      <span>Chargement des produits...</span>
    </div>
  } @else if ((products ?? []).length === 0) {
    <div class="empty-state">
      <i class="pi pi-box text-3xl mb-2 text-gray-500"></i>
      <span>Aucun produit disponible</span>
    </div>
  } @else {
    <div class="products-grid">
      @for (product of products ?? []; track product.id) {
        <div class="product-card">
          <div class="product-header">
            <div class="product-name">
              {{ product.product.name }}
            </div>
            <p-tag
              [value]="product.productStatus.name"
              [style]="{ backgroundColor: product.productStatus.color }"
              styleClass="status-tag"
              [style.color]="'#fff'"
            >
            </p-tag>
          </div>
          <div class="product-details">
            <div class="detail-item">
              <span class="detail-label">
                <i class="pi pi-euro"></i>
              </span>
              <span class="detail-value">{{
                product.price | currency: 'EUR'
              }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">
                <i class="pi pi-hashtag"></i>
              </span>
              <span class="detail-value">{{ product.quantity }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">
                <i class="pi pi-database"></i>
              </span>
              <span class="detail-value">
                <i
                  class="tll tll-16 fa-logo-{{ product.erpSource }} mr-1 text-{{
                    product.erpSource
                  }}"
                ></i>
              </span>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
